export default "__VITE_ASSET__C0W1x1vP__"